import { getPage } from '@/common/asset-apis/common';
import { FieldMeta } from '../types';

export async function getModule(moduleCode: string) {
  return new Promise((resolve, reject) => {
    getPage({
      moduleCode: 'da_logic_entity',
      condition: 'code=${code}',
      parameters: {
        code: moduleCode,
      },
    }).then((res) => {
      if (!res.data || res.data.length !== 1) {
        reject(`获取模型异常 ${moduleCode}`);
      }
      resolve(res.data[0]);
    });
  });
}

export async function getField(module: any, fieldCode: string): Promise<FieldMeta> {
  return new Promise((resolve, reject) => {
    getPage({
      moduleCode: 'da_entity_attribute',
      condition: 'entityId=${entityId} AND code=${code}',
      parameters: {
        entityId: module.id,
        code: fieldCode,
      },
    }).then((res) => {
      if (!res.data || res.data.length !== 1) {
        reject(`获取模型字段异常 ${fieldCode}`);
      }
      resolve(res.data[0]);
    });
  });
}

export async function getBizComponent(componentsCode: string): Promise<any> {
  return new Promise((resolve, reject) => {
    getPage({
      namespace: 'tech',
      moduleCode: 'bizz_components_config',
      condition: 'code=${code}',
      parameters: {
        code: componentsCode,
      },
    }).then((res) => {
      if (!res.data || res.data.length !== 1) {
        console.warn(`获取业务组件异常${componentsCode}`);
        reject();
      }
      resolve(res.data[0]);
    });
  });
}
